import script from "./idtags.vue?vue&type=script&setup=true&lang=js"
export * from "./idtags.vue?vue&type=script&setup=true&lang=js"

import "./idtags.vue?vue&type=style&index=0&id=1de95546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de95546"]])

export default __exports__